import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { DOC_TYPE_OPTIONS } from "@/lib/docTypeOptions";

export default function NewDocument() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5 max-w-2xl">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-muted-foreground text-sm" data-testid="new-doc-back"><ArrowLeft className="h-4 w-4" /> Voltar</button>
      <div><h1 className="font-display font-extrabold text-2xl sm:text-3xl">Escolha o documento</h1><p className="text-muted-foreground">Qual documento você quer criar agora?</p></div>
      <div className="space-y-3">
        {DOC_TYPE_OPTIONS.map((o) => (
          <Card key={o.type} onClick={() => navigate(`/documents/new/${o.type}`)} data-testid={`choose-${o.type}`}
            className="p-5 flex items-center gap-4 cursor-pointer hover:border-primary hover:shadow-md transition-all active:scale-[0.98]">
            <div className={`h-14 w-14 rounded-2xl flex items-center justify-center ${o.color}`}><o.Icon className="h-7 w-7" /></div>
            <div><h3 className="font-display font-bold text-lg">{o.label}</h3><p className="text-sm text-muted-foreground">{o.desc}</p></div>
          </Card>
        ))}
      </div>
    </div>
  );
}
